// Keep native Shopify consent controls and handlers; align keyboard and visual order.
(() => {
  const arrange = (root) => {
    const banner = root.id === 'shopify-pc__banner' ? root : root.querySelector?.('#shopify-pc__banner');
    if (!banner) return false;
    const accept = banner.querySelector('#shopify-pc__banner__btn-accept');
    const decline = banner.querySelector('#shopify-pc__banner__btn-decline');
    const preferences = banner.querySelector('#shopify-pc__banner__btn-manage-prefs');
    if (!accept || !decline || !preferences || accept.parentElement !== decline.parentElement) return false;
    accept.before(decline);
    accept.after(preferences);
    return true;
  };
  if (arrange(document)) return;
  const observer = new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node.nodeType === Node.ELEMENT_NODE && (arrange(node) || arrange(node.closest('#shopify-pc__banner') || node))) {
          observer.disconnect();
          return;
        }
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
